import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-65651957"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "informationModal",
  tabindex: "-1",
  "aria-labelledby": "informationModal",
  "aria-hidden": "true",
  "data-bs-focus": "false"
}
const _hoisted_2 = {
  class: "modal-dialog modal-lg",
  style: {"max-width":"900px"}
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = { class: "modal-body content" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row col-12 mx-0 px-0" }
const _hoisted_11 = { class: "col-12 px-0" }
const _hoisted_12 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_14 = { class: "row mx-0 col-6 px-0 pr-10" }
const _hoisted_15 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "mx-0 col-6 px-0 pl-10" }
const _hoisted_18 = { class: "mx-0 px-0 col-lg-12" }
const _hoisted_19 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_20 = ["placeholder"]
const _hoisted_21 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_22 = {
  key: 1,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_23 = { class: "row mx-0 col-6 px-0 pr-10" }
const _hoisted_24 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "mx-0 col-6 px-0 pl-10" }
const _hoisted_27 = { class: "mx-0 px-0 col-lg-12" }
const _hoisted_28 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_29 = ["placeholder"]
const _hoisted_30 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_31 = {
  key: 2,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_32 = { class: "row mx-0 col-6 px-0 pr-10" }
const _hoisted_33 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_36 = { class: "row justify-content-between align-items-baseline" }
const _hoisted_37 = { class: "col-lg-5" }
const _hoisted_38 = { class: "input-group" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_40 = { class: "col-lg-2 py-2 py-lg-0 d-flex align-items-center justify-content-lg-center" }
const _hoisted_41 = { class: "col-lg-5" }
const _hoisted_42 = { class: "input-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_44 = {
  key: 3,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_45 = { class: "row mx-0 col-lg-6 px-0 pr-10" }
const _hoisted_46 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_49 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_50 = ["placeholder"]
const _hoisted_51 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_52 = {
  key: 4,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_53 = { class: "row mx-0 col-lg-6 px-0 pr-10" }
const _hoisted_54 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_57 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_58 = {
  key: 5,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 justify-content-between"
}
const _hoisted_59 = { class: "row col-6 px-0 mx-0 pr-10" }
const _hoisted_60 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "row pl-0 col-6 justify-content-between px-0 mx-0 pl-10" }
const _hoisted_63 = { class: "mx-0 pl-0 col-lg-6 d-flex justify-content-between" }
const _hoisted_64 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_65 = ["placeholder"]
const _hoisted_66 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_67 = { class: "mx-0 col-lg-6 d-flex justify-content-between pr-0" }
const _hoisted_68 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_69 = ["placeholder"]
const _hoisted_70 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_71 = { key: 1 }
const _hoisted_72 = { class: "row px-0 mx-0" }
const _hoisted_73 = { class: "col-12 px-0" }
const _hoisted_74 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_75 = {
  key: 0,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_76 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_77 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_80 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_81 = ["placeholder"]
const _hoisted_82 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_83 = {
  key: 1,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_84 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_85 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_86 = { key: 0 }
const _hoisted_87 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_88 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_89 = ["placeholder"]
const _hoisted_90 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_91 = {
  key: 2,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_92 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_93 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_94 = { key: 0 }
const _hoisted_95 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_96 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_97 = ["placeholder"]
const _hoisted_98 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_99 = {
  key: 3,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_100 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_101 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_102 = { key: 0 }
const _hoisted_103 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_104 = { class: "row justify-content-between align-items-baseline" }
const _hoisted_105 = { class: "col-lg-5" }
const _hoisted_106 = { class: "input-group" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_108 = { class: "col-lg-2 py-2 py-lg-0 d-flex align-items-center justify-content-lg-center" }
const _hoisted_109 = { class: "col-lg-5" }
const _hoisted_110 = { class: "input-group" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_112 = {
  key: 4,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_113 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_114 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_117 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_118 = ["placeholder"]
const _hoisted_119 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_120 = {
  key: 5,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7"
}
const _hoisted_121 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_122 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_123 = { key: 0 }
const _hoisted_124 = { class: "mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_125 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_126 = {
  key: 6,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 justify-content-between"
}
const _hoisted_127 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_128 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_129 = { key: 0 }
const _hoisted_130 = { class: "row pl-0 col-6 justify-content-between px-0 mx-0 pl-10" }
const _hoisted_131 = { class: "mx-0 pl-0 col-lg-6 d-flex justify-content-between" }
const _hoisted_132 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_133 = ["placeholder"]
const _hoisted_134 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_135 = { class: "mx-0 col-lg-6 d-flex justify-content-between pr-0" }
const _hoisted_136 = { class: "flex-basic-80 mx-lg-0 mx-2 mb-3 mb-lg-0" }
const _hoisted_137 = ["placeholder"]
const _hoisted_138 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_139 = { key: 2 }
const _hoisted_140 = { class: "row px-0 mx-0" }
const _hoisted_141 = { class: "col-12 px-0" }
const _hoisted_142 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_143 = {
  key: 0,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 text-break"
}
const _hoisted_144 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_145 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_146 = { key: 0 }
const _hoisted_147 = { class: "row mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_148 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_149 = ["placeholder"]
const _hoisted_150 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_151 = {
  key: 1,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 text-break"
}
const _hoisted_152 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_153 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_154 = { key: 0 }
const _hoisted_155 = { class: "row mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_156 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_157 = ["placeholder"]
const _hoisted_158 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_159 = {
  key: 2,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 text-break"
}
const _hoisted_160 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_161 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_162 = { key: 0 }
const _hoisted_163 = { class: "row mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_164 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_165 = ["placeholder"]
const _hoisted_166 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_167 = {
  key: 3,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 text-break"
}
const _hoisted_168 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_169 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_170 = { key: 0 }
const _hoisted_171 = { class: "row mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_172 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_173 = ["placeholder"]
const _hoisted_174 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_175 = {
  key: 4,
  class: "row col-12 border-bottom mx-0 px-0 pb-4 gx-3 mb-4 fs-7 text-break"
}
const _hoisted_176 = { class: "mx-0 row col-lg-6 px-0 pr-10" }
const _hoisted_177 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_178 = { key: 0 }
const _hoisted_179 = { class: "row mx-0 col-lg-6 px-0 pl-10" }
const _hoisted_180 = { class: "col-lg-12 px-2 px-lg-0" }
const _hoisted_181 = ["placeholder"]
const _hoisted_182 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_183 = { class: "fw-bold fs-6 p-2 mb-3" }
const _hoisted_184 = { class: "col-lg-12" }
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "w-max-content" }, /*#__PURE__*/_toDisplayString('編集内容に関するメモを登録・更新することができます。'), -1))
const _hoisted_186 = { class: "col-lg-12" }
const _hoisted_187 = {
  key: 0,
  class: "invalid-error"
}
const _hoisted_188 = { class: "modal-footer d-flex justify-content-center" }

import Status from '@/components/status/index.vue'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import { ALUMNI_REGISTER_FORM_STORE, COMMUNITY_ALUMNUS_STORE, REGISTER_STORE, ROOT_STORE } from '@/store/constants'
import { computed, nextTick, onMounted, ref, watch } from 'vue'
import dayjs from 'dayjs'
import { useStore } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import { configYM } from '@/constants/datepicker'
import useVuelidate from '@vuelidate/core'
import { requiredIf, email } from '@vuelidate/validators'
import { MAX_LENGTH_EMAIL, MIN_LENGTH_EMAIL } from '@/constants/number'
import {
  checkAdditionalInformationChoiceOptionDisplayData,
  customMaxLength,
  // getAdditionalInformationChoiceOptionDisplayDataOE30,  // HoaVQ - #14378
  getAdditionalInformationChoiceOptionDisplayDataOE30Input,
  scrollToErrors,
} from '@/utils'
import { REGEX_EMOJI } from '@/constants/regex'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { useRoute } from 'vue-router'
import Loading from '@/components/loading/index.vue'
import { useToast } from 'vue-toastification'
import ErrorToast from '@/components/toast-error/index404.vue'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

export default /*#__PURE__*/_defineComponent({
  props: {
  dataConfirm: Object,
  visible: Boolean,
},
  emits: ['onCloseModal', 'onConfirm'],
  setup(__props, { expose, emit }) {

const props = __props

dayjs.extend(isSameOrAfter)
const toast = useToast()
const store = useStore()
const route = useRoute()

const title_data = computed(() => store.getters[ALUMNI_REGISTER_FORM_STORE.GETTERS.ENTRY_FORM])
const dataDetail = computed(() => store.getters[COMMUNITY_ALUMNUS_STORE.GETTERS.GET_DETAIL_ALMNUS]?.detailAlmnus)


const loadingButton = ref<boolean>(false)
const requiredCorporationStartPeriod = ref(false)
const requiredCorporationEndPeriod = ref(false)
const requiredSchoolStartPeriod = ref(false)
const requiredSchoolEndPeriod = ref(false)

const formData = ref({
  corporation_organization_name: '',
  corporation_department_name: '',
  corporation_employee_id: '',
  corporation_email: '',
  corporation_start_period: '',
  corporation_end_period: '',
  corporation_family_name: '',
  corporation_given_name: '',
  school_organization_name: '',
  school_faclty_name: '',
  school_department_name: '',
  school_start_period: '',
  school_end_period: '',
  school_student_id: '',
  school_email: '',
  school_family_name: '',
  school_given_name: '',
  additional_information_1: '',
  additional_information_2: '',
  additional_information_3: '',
  additional_information_4: '',
  additional_information_5: '',
  corporation_edit_history_notes: '',
})

const isCheckedNGCorporationOrganizationName = { value: false }
const ngKeyCorporationOrganizationName = ref<boolean>(false)
const checkNGCorporationOrganizationName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_organization_name.$model })
  ngKeyCorporationOrganizationName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationOrganizationName.value = true
}, 200)
const ngKeyCorporationDepartmentName = ref<boolean>(false)
const isCheckedNGCorporationDepartmentName = { value: false }
const checkNGCorporationDepartmentName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_department_name.$model })
  ngKeyCorporationDepartmentName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationDepartmentName.value = true
}, 200)
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])
const isCheckedNGCorporationFamilyName = { value: false }
const ngKeyCorporationFamilyName = ref<boolean>(false)
const checkNGCorporationFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_family_name.$model })
  ngKeyCorporationFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationFamilyName.value = true
}, 200)
const placeholderDefault = translate('placeholder')
const isCheckedNGCorporationGivenName = { value: false }
const ngKeyCorporationGivenName = ref<boolean>(false)
const checkNGCorporationGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_given_name.$model })
  ngKeyCorporationGivenName.value = data.data?.data?.has_ngword
  isCheckedNGCorporationGivenName.value = true
}, 200)
const isCheckedNGSchoolFacltyName = { value: false }
const ngKeySchoolFacltyName = ref<boolean>(false)
const checkNGSchoolFacltyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_faclty_name.$model })
  ngKeySchoolFacltyName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolFacltyName.value = true
}, 200)
const isCheckedNGSchoolDepartmentName = { value: false }
const ngKeySchoolDepartmentName = ref<boolean>(false)
const checkNGSchoolDepartmentName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_department_name.$model })
  ngKeySchoolDepartmentName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolDepartmentName.value = true
}, 200)
const isCheckedNGSchoolFamilyName = { value: false }
const ngKeySchoolFamilyName = ref<boolean>(false)
const checkNGSchoolFamilyName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_family_name.$model })
  ngKeySchoolFamilyName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolFamilyName.value = true
}, 200)
const isCheckedNGSchoolGivenName = { value: false }
const ngKeySchoolGivenName = ref<boolean>(false)
const checkNGSchoolGivenName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_given_name.$model })
  ngKeySchoolGivenName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolGivenName.value = true
}, 200)
const isCheckedNGAdditionalInformation1 = { value: false }
const ngKeyAdditionalInformation1 = ref<boolean>(false)
const checkNGAdditionalInformation1 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_1.$model })
  ngKeyAdditionalInformation1.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation1.value = true
}, 200)

const isCheckedNGAdditionalInformation2 = { value: false }
const ngKeyAdditionalInformation2 = ref<boolean>(false)
const checkNGAdditionalInformation2 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_2.$model })
  ngKeyAdditionalInformation2.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation2.value = true
}, 200)

const isCheckedNGAdditionalInformation3 = { value: false }
const ngKeyAdditionalInformation3 = ref<boolean>(false)
const checkNGAdditionalInformation3 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_3.$model })
  ngKeyAdditionalInformation3.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation3.value = true
}, 200)

const isCheckedNGAdditionalInformation4 = { value: false }
const ngKeyAdditionalInformation4 = ref<boolean>(false)
const checkNGAdditionalInformation4 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_4.$model })
  ngKeyAdditionalInformation4.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation4.value = true
}, 200)

const isCheckedNGAdditionalInformation5 = { value: false }
const ngKeyAdditionalInformation5 = ref<boolean>(false)
const checkNGAdditionalInformation5 = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.additional_information_5.$model })
  ngKeyAdditionalInformation5.value = data.data?.data?.has_ngword
  isCheckedNGAdditionalInformation5.value = true
}, 200)

const isCheckedNGCorporationHistoryNote = { value: false }
const ngKeyCorporationHistoryNote = ref<boolean>(false)
const checkNGCorporationHistoryNote = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_edit_history_notes.$model })
  ngKeyCorporationHistoryNote.value = data.data?.data?.has_ngword
  isCheckedNGCorporationHistoryNote.value = true
}, 200)
const isCheckedNGSchoolOrganizationName = { value: false }
const ngKeySchoolOrganizationName = ref<boolean>(false)
const checkNGSchoolOrganizationName = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_organization_name.$model })
  ngKeySchoolOrganizationName.value = data.data?.data?.has_ngword
  isCheckedNGSchoolOrganizationName.value = true
}, 200)
const ngKeyCorporationEmployeeID = ref<boolean>(false)
const isCheckedNGCorporationEmployeeID = { value: false }
const checkNGCorporationEmployeeID = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.corporation_employee_id.$model })
  ngKeyCorporationEmployeeID.value = data.data?.data?.has_ngword
  isCheckedNGCorporationEmployeeID.value = true
}, 200)

const ngKeySchoolStudentID = ref<boolean>(false)
const isCheckedNGSchoolStudentID = { value: false }
const checkNGSchoolStudentID = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.school_student_id.$model })
  ngKeySchoolStudentID.value = data.data?.data?.has_ngword
  isCheckedNGSchoolStudentID.value = true
}, 200)

const communityRequiredData = computed(() => store.getters[REGISTER_STORE.GETTERS.COMMUNITY_REQUIRED_COLUMNS])

onMounted(async () => {
  const modal = document.querySelector('#informationModal')
  modal.addEventListener('hidden.bs.modal', function () {
    onCloseModal()
  })
  requiredCorporationStartPeriod.value = true
  requiredCorporationEndPeriod.value = true
  requiredSchoolStartPeriod.value = true
  requiredSchoolEndPeriod.value = true
  try {
    if (route?.params?.id) {
      await store.dispatch(REGISTER_STORE.ACTIONS.SET_COMMUNITY_REQUIRED_COLUMNS, route?.params?.id)
    }
    if (!dataDetail.value?.obtained_information) {
      await store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DETAIL_ALMNUS, { id: route.params?.id, idAlumni: route.params?.idAlumni, management_no: 'desc' })
    }
  } catch (error) {
    console.log(error)
  }
})

const rules = computed(() => {
  return {
    corporation_organization_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_organization_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    corporation_department_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_department_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_start_period: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_start_period === 1 || false
      }),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },

    corporation_end_period: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_end_period === 1 || false
      }),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
      afterStartDate(value) {
        const data = communityRequiredData?.value
        if (!data) return true

        const { corporation_start_period, corporation_end_period } = data

        if (corporation_start_period === 0 && corporation_end_period === 0) {
          return true
        }

        if (!value) return true

        const startDate = dayjs(convertDate(formData.value.corporation_start_period))
        const currentDate = dayjs(convertDate(value))
        return currentDate.isSameOrAfter(startDate)
      },
    },

    corporation_employee_id: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_employee_id === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_email: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_email === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },

    corporation_family_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_family_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    corporation_given_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.corporation_given_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_faclty_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_faclty_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_department_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_department_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_start_period: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_start_period === 1 || false
      }),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
    },

    school_end_period: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_end_period === 1 || false
      }),
      maxDate: function (value) {
        const date = dayjs(value).format('YYYY-MM-DD')
        if (!dayjs().isBefore(dayjs(date))) return true
      },
      minDate: function (value) {
        if (dayjs(value).format('YYYY-MM-DD') >= dayjs('01/01/1900').format('YYYY-MM-DD')) return true
      },
      afterStartDate(value) {
        const data = communityRequiredData?.value
        if (!data) return true

        const { school_start_period, school_end_period } = data

        if (school_start_period === 0 && school_end_period === 0) {
          return true
        }

        if (!value) return true

        const startDate = dayjs(convertDate(formData.value.school_start_period))
        const currentDate = dayjs(convertDate(value))
        return currentDate.isSameOrAfter(startDate)
      },
    },

    school_student_id: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_student_id === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_email: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_email === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, MAX_LENGTH_EMAIL),
      email,
    },

    school_family_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_family_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },

    school_given_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_given_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 20),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_1: {
      required: requiredIf(() => {
        return communityRequiredData.value?.additional_information_1 === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 600),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_2: {
      required: requiredIf(() => {
        return communityRequiredData.value?.additional_information_2 === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 600),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_3: {
      required: requiredIf(() => {
        return communityRequiredData.value?.additional_information_3 === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 600),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_4: {
      required: requiredIf(() => {
        return communityRequiredData.value?.additional_information_4 === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 600),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    additional_information_5: {
      required: requiredIf(() => {
        return communityRequiredData.value?.additional_information_5 === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 600),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    corporation_edit_history_notes: {
      maxString: (value: string) => customMaxLength(value, 300),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
    school_organization_name: {
      required: requiredIf(() => {
        return communityRequiredData.value?.school_organization_name === 1 || false
      }),
      maxLength: (value: string) => customMaxLength(value, 100),
      emoji: function (value) {
        if (value !== '') return REGEX_EMOJI.test(value)
        return true
      },
    },
  }
})

const v$ = useVuelidate(rules, formData)

const handleFormData = (data) => {
  Object.keys(formData.value).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      formData.value[key] = data[key] || ''
    }
  })
}

watch(
  () => dataDetail.value?.obtained_information,
  (newValue) => {
    if (newValue) {
      handleFormData(newValue)
    }
  },
  { immediate: true }
)

watch(
  () => props.dataConfirm,
  (newValue) => {
    if (newValue) {
      if (newValue) {
        handleFormData(newValue)
        v$.value.$touch()
      }
    }
  },
  { deep: true }
)
watch(
  () => props.visible,
  (newValue) => {
    if (newValue == true) {
      // Check type of data  additional_information_1=>5
      setTimeout(() => {
        if (checkAdditionalInformationChoiceOptionDisplayData(dataDetail?.value?.obtained_information?.additional_information_1)) {
          formData.value.additional_information_1 = getAdditionalInformationChoiceOptionDisplayDataOE30Input(dataDetail?.value?.obtained_information?.additional_information_1)
        } else {
          formData.value.additional_information_1 = checkDisplayEmpty(formData.value.additional_information_1)
        }
        if (checkAdditionalInformationChoiceOptionDisplayData(dataDetail?.value?.obtained_information?.additional_information_2)) {
          formData.value.additional_information_2 = getAdditionalInformationChoiceOptionDisplayDataOE30Input(dataDetail?.value?.obtained_information?.additional_information_2)
        } else {
          formData.value.additional_information_2 = checkDisplayEmpty(formData.value.additional_information_2)
        }
        if (checkAdditionalInformationChoiceOptionDisplayData(dataDetail?.value?.obtained_information?.additional_information_3)) {
          formData.value.additional_information_3 = getAdditionalInformationChoiceOptionDisplayDataOE30Input(dataDetail?.value?.obtained_information?.additional_information_3)
        } else {
          formData.value.additional_information_3 = checkDisplayEmpty(formData.value.additional_information_3)
        }
        if (checkAdditionalInformationChoiceOptionDisplayData(dataDetail?.value?.obtained_information?.additional_information_4)) {
          formData.value.additional_information_4 = getAdditionalInformationChoiceOptionDisplayDataOE30Input(dataDetail?.value?.obtained_information?.additional_information_4)
        } else {
          formData.value.additional_information_4 = checkDisplayEmpty(formData.value.additional_information_4)
        }
        if (checkAdditionalInformationChoiceOptionDisplayData(dataDetail?.value?.obtained_information?.additional_information_5)) {
          formData.value.additional_information_5 = getAdditionalInformationChoiceOptionDisplayDataOE30Input(dataDetail?.value?.obtained_information?.additional_information_5)
        } else {
          formData.value.additional_information_5 = checkDisplayEmpty(formData.value.additional_information_5)
        }
      }, 10)
    }
  },
  { deep: true }
)

const getFilteredData = () => {
  const filteredData: Record<string, string> = {}

  for (const key in communityRequiredData.value) {
    if (communityRequiredData.value[key] === 1 || communityRequiredData.value[key] === 2) {
      if (Object.prototype.hasOwnProperty.call(formData.value, key)) {
        filteredData[key] = formData.value[key as keyof typeof formData.value]
      }
    }
  }
  filteredData['corporation_edit_history_notes'] = formData.value.corporation_edit_history_notes

  return filteredData
}

const onCloseModal = () => {
  v$.value.$reset()
  requiredCorporationStartPeriod.value = false
  requiredCorporationEndPeriod.value = false
  requiredSchoolStartPeriod.value = false
  requiredSchoolEndPeriod.value = false
  emit('onCloseModal')
}

const convertDate = (dateStr) => {
  if (!dateStr) return
  // 2020/02/01=> 2020/02
  if (dateStr) {
    let [year, month] = dateStr.split('/')
    return `${year}/${month}`
  }
}

const isTrueOrUndefined = (value: any) => {
  return value === undefined || value
}

const onSubmit = async () => {
  loadingButton.value = true
  v$.value.$touch()
  // if (v$.value.$invalid || checkNgWord) {
  //   nextTick(() => {
  //     scrollToErrors('.invalid-feedback', '#informationModal')
  //   })
  //   loadingButton.value = false
  //   return
  // }
  if (communityRequiredData?.value?.corporation_start_period !== 0 || communityRequiredData?.value?.corporation_end_period !== 0) {
    const corporation_end_period = convertDate(formData.value.corporation_end_period)
    const corporation_start_period = convertDate(formData.value.corporation_start_period)

    if (!dayjs(corporation_end_period).isSameOrAfter(dayjs(corporation_start_period))) {
      toast.error(
        {
          component: ErrorToast,
          props: {
            messageCode: 'afterStartDateEnrollment',
          },
        },
        { timeout: 2000 }
      )

      loadingButton.value = false
      return
    }
  }

  if (communityRequiredData?.value?.school_start_period !== 0 || communityRequiredData?.value?.school_end_period !== 0) {
    const school_end_period = convertDate(formData.value.school_end_period)
    const school_start_period = convertDate(formData.value.school_start_period)

    if (!dayjs(school_end_period).isSameOrAfter(dayjs(school_start_period))) {
      toast.error(
        {
          component: ErrorToast,
          props: {
            messageCode: 'afterStartDatePeriodOfEnrollment',
          },
        },
        { timeout: 2000 }
      )
      loadingButton.value = false
      return
    }
  }

  const isCheckedNGItems: Array<{ value: boolean }> = [
    isCheckedNGCorporationOrganizationName,
    isCheckedNGCorporationDepartmentName,
    isCheckedNGCorporationFamilyName,
    isCheckedNGCorporationGivenName,
    isCheckedNGSchoolFacltyName,
    isCheckedNGSchoolDepartmentName,
    isCheckedNGSchoolFamilyName,
    isCheckedNGSchoolGivenName,
    isCheckedNGAdditionalInformation1,
    isCheckedNGAdditionalInformation2,
    isCheckedNGAdditionalInformation3,
    isCheckedNGAdditionalInformation4,
    isCheckedNGAdditionalInformation5,
    isCheckedNGCorporationHistoryNote,
    isCheckedNGSchoolOrganizationName,
    isCheckedNGCorporationEmployeeID,
    isCheckedNGSchoolStudentID,
  ]
  isCheckedNGItems.forEach((checkedNGItem) => (checkedNGItem.value = false))

  const results = await Promise.allSettled([
    checkNGCorporationOrganizationName(),
    checkNGCorporationDepartmentName(),
    checkNGCorporationFamilyName(),
    checkNGCorporationGivenName(),
    checkNGSchoolFacltyName(),
    checkNGSchoolDepartmentName(),
    checkNGSchoolFamilyName(),
    checkNGSchoolGivenName(),
    checkNGAdditionalInformation1(),
    checkNGAdditionalInformation2(),
    checkNGAdditionalInformation3(),
    checkNGAdditionalInformation4(),
    checkNGAdditionalInformation5(),
    checkNGCorporationHistoryNote(),
    checkNGSchoolOrganizationName(),
    checkNGCorporationEmployeeID(),
    checkNGSchoolStudentID(),
  ])
  // Check result valid
  results.forEach((result, index) => {
    if (result.status === 'rejected') {
      console.error('Promise rejected:', result)
      // console.log('Promise rejected:', result) // report error
      // if error exist
      loadingButton.value = false
      return
    } else {
      // console.log('Promise resolved:', result.value)
    }
  })
  while (!isCheckedNGItems.every((checkedNGItem) => checkedNGItem.value)) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (
    v$.value.$invalid ||
    isTrueOrUndefined(ngKeyCorporationOrganizationName.value) ||
    isTrueOrUndefined(ngKeyCorporationDepartmentName.value) ||
    isTrueOrUndefined(ngKeyCorporationFamilyName.value) ||
    isTrueOrUndefined(ngKeyCorporationGivenName.value) ||
    isTrueOrUndefined(ngKeySchoolFacltyName.value) ||
    isTrueOrUndefined(ngKeySchoolDepartmentName.value) ||
    isTrueOrUndefined(ngKeySchoolFamilyName.value) ||
    isTrueOrUndefined(ngKeySchoolGivenName.value) ||
    isTrueOrUndefined(ngKeyAdditionalInformation1.value) ||
    isTrueOrUndefined(ngKeyAdditionalInformation2.value) ||
    isTrueOrUndefined(ngKeyAdditionalInformation3.value) ||
    isTrueOrUndefined(ngKeyAdditionalInformation4.value) ||
    isTrueOrUndefined(ngKeyAdditionalInformation5.value) ||
    isTrueOrUndefined(ngKeyCorporationHistoryNote.value) ||
    isTrueOrUndefined(ngKeySchoolOrganizationName.value) ||
    isTrueOrUndefined(ngKeyCorporationEmployeeID.value) ||
    isTrueOrUndefined(ngKeySchoolStudentID.value)
  ) {
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#informationModal')
    })
    loadingButton.value = false
    return
  }
  try {
    // Show modal confirm information
    const formDataConfirm = getFilteredData()
    emit('onConfirm', formDataConfirm)
    loadingButton.value = false
  } catch (error) {
    loadingButton.value = false
    console.log('error', error)
  }
}

const handleClick = () => {
  requiredCorporationStartPeriod.value = true
  requiredCorporationEndPeriod.value = true
  requiredSchoolStartPeriod.value = true
  requiredSchoolEndPeriod.value = true
}

const checkDisplayEmpty = (value) => {
  if (value === '[]') return ''
  return value
}

expose({
  handleFormData,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE30editAddition')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: onCloseModal
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (
                  _unref(communityRequiredData)?.corporation_organization_name !== 0 ||
                  _unref(communityRequiredData)?.corporation_department_name !== 0 ||
                  _unref(communityRequiredData)?.corporation_start_period !== 0 ||
                  _unref(communityRequiredData)?.corporation_end_period !== 0 ||
                  _unref(communityRequiredData)?.corporation_employee_id !== 0 ||
                  _unref(communityRequiredData)?.corporation_email !== 0 ||
                  _unref(communityRequiredData)?.corporation_family_name !== 0 ||
                  _unref(communityRequiredData)?.corporation_given_name !== 0
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("h3", _hoisted_12, _toDisplayString(_unref(translate)('SA20information')), 1)
                        ])
                      ]),
                      (_unref(communityRequiredData)?.corporation_organization_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20corporationOrganizationName')), 1),
                                (_unref(communityRequiredData).corporation_organization_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeyCorporationOrganizationName.value || _unref(v$).corporation_organization_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).corporation_organization_name.$model) = $event)),
                                    onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationOrganizationName) && _unref(checkNGCorporationOrganizationName)(...args))),
                                    placeholder: _unref(placeholderDefault)
                                  }, null, 42, _hoisted_20), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_organization_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationOrganizationName.value && !_unref(v$).corporation_organization_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${'SA20'}corporationOrganizationName`),
                                    params: [1, 100],
                                    validator: _unref(v$).corporation_organization_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.corporation_department_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('enrolledDepartmentName')), 1),
                                (_unref(communityRequiredData).corporation_department_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: _normalizeClass(['form-control', ngKeyCorporationDepartmentName.value || _unref(v$).corporation_department_name.$error ? 'is-invalid' : '']),
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).corporation_department_name.$model) = $event)),
                                    onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationDepartmentName) && _unref(checkNGCorporationDepartmentName)(...args))),
                                    placeholder: _unref(translate)(`${'SA20'}placeholderDepartment`)
                                  }, null, 42, _hoisted_29), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_department_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationDepartmentName.value && !_unref(v$).corporation_department_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${'SA20'}department`),
                                    params: [1, 100],
                                    validator: _unref(v$).corporation_department_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.corporation_start_period !== 0 || _unref(communityRequiredData)?.corporation_end_period !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('enrollment')), 1),
                                (_unref(communityRequiredData).corporation_start_period === 1 || _unref(communityRequiredData).corporation_end_period === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_35, [
                              _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                  _createElementVNode("div", _hoisted_38, [
                                    _createVNode(_unref(flatPickr), {
                                      modelValue: _unref(v$).corporation_start_period.$model,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).corporation_start_period.$model) = $event)),
                                      placeholder: "2000/01",
                                      config: _unref(configYM)(_unref(v$).corporation_start_period.$model),
                                      class: _normalizeClass(['form-control bg-white', _unref(v$).corporation_start_period.$error ? 'is-invalid' : '']),
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (handleClick()))
                                    }, null, 8, ["modelValue", "config", "class"]),
                                    _hoisted_39
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`SA20fromEnrollmentPeriod`),
                                    params: [1900, 1],
                                    validator: requiredCorporationStartPeriod.value ? _unref(v$).corporation_start_period.$errors[0]?.$validator : ''
                                  }, null, 8, ["title", "validator"])
                                ]),
                                _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(translate)('SA20from')), 1),
                                _createElementVNode("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    _createVNode(_unref(flatPickr), {
                                      modelValue: _unref(v$).corporation_end_period.$model,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).corporation_end_period.$model) = $event)),
                                      placeholder: "2000/01",
                                      config: _unref(configYM)(_unref(v$).corporation_end_period.$model),
                                      class: _normalizeClass(['form-control bg-white', _unref(v$).corporation_end_period.$error ? 'is-invalid' : '']),
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (handleClick()))
                                    }, null, 8, ["modelValue", "config", "class"]),
                                    _hoisted_43
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`SA20toEnrollmentPeriod`),
                                    params: [1900, 1],
                                    validator: requiredCorporationEndPeriod.value ? _unref(v$).corporation_end_period.$errors[0]?.$validator : ''
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.corporation_employee_id !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createElementVNode("div", _hoisted_45, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA25employeeID')), 1),
                                (_unref(communityRequiredData).corporation_employee_id === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("div", _hoisted_49, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(v$).corporation_employee_id.$model) = $event)),
                                  class: _normalizeClass(['form-control', ngKeyCorporationEmployeeID.value || _unref(v$).corporation_employee_id.$error ? 'is-invalid' : '']),
                                  placeholder: _unref(translate)(`${'SA20'}placeholderID`),
                                  onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationEmployeeID) && _unref(checkNGCorporationEmployeeID)(...args)))
                                }, null, 42, _hoisted_50), [
                                  [
                                    _vModelText,
                                    _unref(v$).corporation_employee_id.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeyCorporationEmployeeID.value && !_unref(v$).corporation_employee_id.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}employeeID`),
                                  params: [1, 20],
                                  validator: _unref(v$).corporation_employee_id.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.corporation_email !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('enrolledTimeEmailID')), 1),
                                (_unref(communityRequiredData).corporation_email === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "email",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).corporation_email.$model) = $event)),
                                  class: _normalizeClass(['form-control', _unref(v$).corporation_email.$error ? 'is-invalid' : '']),
                                  placeholder: "sample@yelloop.jp"
                                }, null, 2), [
                                  [
                                    _vModelText,
                                    _unref(v$).corporation_email.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}emailEnrollment`),
                                  params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                                  validator: _unref(v$).corporation_email.$errors[0]?.$validator
                                }, null, 8, ["title", "params", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.corporation_family_name !== 0 || _unref(communityRequiredData)?.corporation_given_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                            _createElementVNode("div", _hoisted_59, [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('OE30nameAtTime')), 1),
                                (_unref(communityRequiredData)?.corporation_family_name === 1 || _unref(communityRequiredData).corporation_given_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_62, [
                              _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${'SA20'}surnameKanji`)), 3),
                                _createElementVNode("div", _hoisted_64, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).corporation_family_name.$model) = $event)),
                                    onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationFamilyName) && _unref(checkNGCorporationFamilyName)(...args))),
                                    class: _normalizeClass(['form-control placeholder-small', ngKeyCorporationFamilyName.value || _unref(v$).corporation_family_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault)
                                  }, null, 42, _hoisted_65), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_family_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationFamilyName.value && !_unref(v$).corporation_family_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${'SA20'}surnameKanji`),
                                    params: [1, 20],
                                    validator: _unref(v$).corporation_family_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${'SA20'}firstName`)), 3),
                                _createElementVNode("div", _hoisted_68, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).corporation_given_name.$model) = $event)),
                                    onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationGivenName) && _unref(checkNGCorporationGivenName)(...args))),
                                    class: _normalizeClass(['form-control placeholder-small', ngKeyCorporationGivenName.value || _unref(v$).corporation_given_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault)
                                  }, null, 42, _hoisted_69), [
                                    [
                                      _vModelText,
                                      _unref(v$).corporation_given_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeyCorporationGivenName.value && !_unref(v$).corporation_given_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${'SA20'}firstName`),
                                    params: [1, 20],
                                    validator: _unref(v$).corporation_given_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
                  _unref(communityRequiredData)?.school_organization_name !== 0 ||
                  _unref(communityRequiredData)?.school_faclty_name !== 0 ||
                  _unref(communityRequiredData)?.school_department_name !== 0 ||
                  _unref(communityRequiredData)?.school_start_period !== 0 ||
                  _unref(communityRequiredData)?.school_end_period !== 0 ||
                  _unref(communityRequiredData)?.school_student_id !== 0 ||
                  _unref(communityRequiredData)?.school_email !== 0 ||
                  _unref(communityRequiredData)?.school_family_name !== 0 ||
                  _unref(communityRequiredData)?.school_given_name !== 0
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("h3", _hoisted_74, _toDisplayString(_unref(translate)('SA20informationAtSchool')), 1)
                        ])
                      ]),
                      (_unref(communityRequiredData)?.school_organization_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                            _createElementVNode("div", _hoisted_76, [
                              _createElementVNode("div", _hoisted_77, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20schoolOrganizationName')), 1),
                                (_unref(communityRequiredData).school_organization_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(['form-control', ngKeySchoolOrganizationName.value || _unref(v$).school_organization_name.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(v$).school_organization_name.$model) = $event)),
                                  onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolOrganizationName) && _unref(checkNGSchoolOrganizationName)(...args))),
                                  placeholder: _unref(translate)(`placeholder`)
                                }, null, 42, _hoisted_81), [
                                  [
                                    _vModelText,
                                    _unref(v$).school_organization_name.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeySchoolOrganizationName.value && !_unref(v$).school_organization_name.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_82, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}schoolOrganizationName`),
                                  params: [1, 100],
                                  validator: _unref(v$).school_organization_name.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.school_faclty_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                            _createElementVNode("div", _hoisted_84, [
                              _createElementVNode("div", _hoisted_85, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20facultyName')), 1),
                                (_unref(communityRequiredData).school_faclty_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _createElementVNode("div", _hoisted_88, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(['form-control', ngKeySchoolFacltyName.value || _unref(v$).school_faclty_name.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(v$).school_faclty_name.$model) = $event)),
                                  onChange: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolFacltyName) && _unref(checkNGSchoolFacltyName)(...args))),
                                  placeholder: _unref(translate)(`SA20placeholderName1`)
                                }, null, 42, _hoisted_89), [
                                  [
                                    _vModelText,
                                    _unref(v$).school_faclty_name.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeySchoolFacltyName.value && !_unref(v$).school_faclty_name.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_90, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}facultyName`),
                                  params: [1, 100],
                                  validator: _unref(v$).school_faclty_name.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.school_department_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                            _createElementVNode("div", _hoisted_92, [
                              _createElementVNode("div", _hoisted_93, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20departmentName')), 1),
                                (_unref(communityRequiredData).school_department_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_95, [
                              _createElementVNode("div", _hoisted_96, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: _normalizeClass(['form-control', ngKeySchoolDepartmentName.value || _unref(v$).school_department_name.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(v$).school_department_name.$model) = $event)),
                                  onChange: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolDepartmentName) && _unref(checkNGSchoolDepartmentName)(...args))),
                                  placeholder: _unref(translate)(`SA20placeholderName2`)
                                }, null, 42, _hoisted_97), [
                                  [
                                    _vModelText,
                                    _unref(v$).school_department_name.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeySchoolDepartmentName.value && !_unref(v$).school_department_name.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_98, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}departmentName`),
                                  params: [1, 100],
                                  validator: _unref(v$).school_department_name.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.school_start_period !== 0 || _unref(communityRequiredData)?.school_end_period !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                            _createElementVNode("div", _hoisted_100, [
                              _createElementVNode("div", _hoisted_101, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20periodOfEnrollment')), 1),
                                (_unref(communityRequiredData)?.school_start_period === 1 || _unref(communityRequiredData)?.school_end_period === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_102, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("div", _hoisted_105, [
                                  _createElementVNode("div", _hoisted_106, [
                                    _createVNode(_unref(flatPickr), {
                                      modelValue: _unref(v$).school_start_period.$model,
                                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(v$).school_start_period.$model) = $event)),
                                      placeholder: "2000/01",
                                      config: _unref(configYM)(_unref(v$).school_start_period.$model),
                                      class: _normalizeClass(['form-control bg-white', _unref(v$).school_start_period.$error ? 'is-invalid' : '']),
                                      onClick: handleClick
                                    }, null, 8, ["modelValue", "config", "class"]),
                                    _hoisted_107
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`SA20fromPeriodOfEnrollment`),
                                    params: [1900, 1],
                                    validator: requiredSchoolStartPeriod.value ? _unref(v$).school_start_period.$errors[0]?.$validator : ''
                                  }, null, 8, ["title", "validator"])
                                ]),
                                _createElementVNode("div", _hoisted_108, _toDisplayString(_unref(translate)('SA20from')), 1),
                                _createElementVNode("div", _hoisted_109, [
                                  _createElementVNode("div", _hoisted_110, [
                                    _createVNode(_unref(flatPickr), {
                                      modelValue: _unref(v$).school_end_period.$model,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(v$).school_end_period.$model) = $event)),
                                      placeholder: "2000/01",
                                      config: _unref(configYM)(_unref(v$).school_end_period.$model),
                                      class: _normalizeClass(['form-control bg-white', _unref(v$).school_end_period.$error ? 'is-invalid' : '']),
                                      onClick: handleClick
                                    }, null, 8, ["modelValue", "config", "class"]),
                                    _hoisted_111
                                  ]),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`SA20toPeriodOfEnrollment`),
                                    params: [1900, 1],
                                    validator: requiredSchoolEndPeriod.value ? _unref(v$).school_end_period.$errors[0]?.$validator : ''
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.school_student_id !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20studentID')), 1),
                                (_unref(communityRequiredData).school_student_id === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_116, [
                              _createElementVNode("div", _hoisted_117, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_unref(v$).school_student_id.$model) = $event)),
                                  class: _normalizeClass(['form-control', ngKeySchoolStudentID.value || _unref(v$).school_student_id.$error ? 'is-invalid' : '']),
                                  onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolStudentID) && _unref(checkNGSchoolStudentID)(...args))),
                                  placeholder: _unref(translate)(`${'SA20'}placeholderID`)
                                }, null, 42, _hoisted_118), [
                                  [
                                    _vModelText,
                                    _unref(v$).school_student_id.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeySchoolStudentID.value && !_unref(v$).school_student_id.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_119, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}studentID`),
                                  params: [1, 20],
                                  validator: _unref(v$).school_student_id.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.school_email !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_120, [
                            _createElementVNode("div", _hoisted_121, [
                              _createElementVNode("div", _hoisted_122, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20emailAttendSchool')), 1),
                                (_unref(communityRequiredData).school_email === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_124, [
                              _createElementVNode("div", _hoisted_125, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "email",
                                  "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_unref(v$).school_email.$model) = $event)),
                                  class: _normalizeClass(['form-control', _unref(v$).school_email.$error ? 'is-invalid' : '']),
                                  placeholder: "sample@yelloop.jp"
                                }, null, 2), [
                                  [
                                    _vModelText,
                                    _unref(v$).school_email.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(translate)(`${'SA20'}emailAttendSchool`),
                                  params: [_unref(MIN_LENGTH_EMAIL), _unref(MAX_LENGTH_EMAIL)],
                                  validator: _unref(v$).school_email.$errors[0]?.$validator
                                }, null, 8, ["title", "params", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.school_family_name !== 0 || _unref(communityRequiredData)?.school_given_name !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                            _createElementVNode("div", _hoisted_127, [
                              _createElementVNode("div", _hoisted_128, [
                                _createElementVNode("label", null, _toDisplayString(_unref(translate)('SA20nameAtSchool')), 1),
                                (_unref(communityRequiredData).school_family_name === 1 || _unref(communityRequiredData).school_given_name === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_130, [
                              _createElementVNode("div", _hoisted_131, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${'SA20'}surnameKanji`)), 3),
                                _createElementVNode("div", _hoisted_132, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(v$).school_family_name.$model) = $event)),
                                    onChange: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolFamilyName) && _unref(checkNGSchoolFamilyName)(...args))),
                                    class: _normalizeClass(['form-control placeholder-small', ngKeySchoolFamilyName.value || _unref(v$).school_family_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault)
                                  }, null, 42, _hoisted_133), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_family_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolFamilyName.value && !_unref(v$).school_family_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_134, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${'SA20'}surnameKanji`),
                                    params: [1, 20],
                                    validator: _unref(v$).school_family_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_135, [
                                _createElementVNode("label", {
                                  class: _normalizeClass(['w-max-content col-form-label text-left', _unref(isMobile) ? 'px-2' : 'name-kanji'])
                                }, _toDisplayString(_unref(translate)(`${'SA20'}firstName`)), 3),
                                _createElementVNode("div", _hoisted_136, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(v$).school_given_name.$model) = $event)),
                                    onChange: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_unref(checkNGSchoolGivenName) && _unref(checkNGSchoolGivenName)(...args))),
                                    class: _normalizeClass(['form-control placeholder-small', ngKeySchoolGivenName.value || _unref(v$).school_given_name.$error ? 'is-invalid' : '']),
                                    placeholder: _unref(placeholderDefault)
                                  }, null, 42, _hoisted_137), [
                                    [
                                      _vModelText,
                                      _unref(v$).school_given_name.$model,
                                      void 0,
                                      { trim: true }
                                    ]
                                  ]),
                                  (ngKeySchoolGivenName.value && !_unref(v$).school_given_name.$error)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_138, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                    : _createCommentVNode("", true),
                                  _createVNode(InputErrorMessage, {
                                    title: _unref(translate)(`${'SA20'}firstName`),
                                    params: [1, 20],
                                    validator: _unref(v$).school_given_name.$errors[0]?.$validator
                                  }, null, 8, ["title", "validator"])
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (
                  _unref(communityRequiredData)?.additional_information_1 !== 0 ||
                  _unref(communityRequiredData)?.additional_information_2 !== 0 ||
                  _unref(communityRequiredData)?.additional_information_3 !== 0 ||
                  _unref(communityRequiredData)?.additional_information_4 !== 0 ||
                  _unref(communityRequiredData)?.additional_information_5 !== 0
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("div", _hoisted_141, [
                          _createElementVNode("h3", _hoisted_142, _toDisplayString(_unref(translate)('SA20additionalInformation')), 1)
                        ])
                      ]),
                      (_unref(communityRequiredData)?.additional_information_1 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_143, [
                            _createElementVNode("div", _hoisted_144, [
                              _createElementVNode("div", _hoisted_145, [
                                _createElementVNode("label", null, _toDisplayString(_unref(title_data)?.additional_information_1_question), 1),
                                (_unref(communityRequiredData).additional_information_1 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_146, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_147, [
                              _createElementVNode("div", _hoisted_148, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  name: "additional_information_1",
                                  class: _normalizeClass(['form-control', ngKeyAdditionalInformation1.value || _unref(v$).additional_information_1.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_unref(v$).additional_information_1.$model) = $event)),
                                  onChange: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation1) && _unref(checkNGAdditionalInformation1)(...args))),
                                  placeholder: _unref(placeholderDefault),
                                  rows: "5"
                                }, null, 42, _hoisted_149), [
                                  [
                                    _vModelText,
                                    _unref(v$).additional_information_1.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeyAdditionalInformation1.value && !_unref(v$).additional_information_1.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_1_question,
                                  params: [1, 600],
                                  validator: _unref(v$).additional_information_1.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.additional_information_2 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                            _createElementVNode("div", _hoisted_152, [
                              _createElementVNode("div", _hoisted_153, [
                                _createElementVNode("label", null, _toDisplayString(_unref(title_data)?.additional_information_2_question), 1),
                                (_unref(communityRequiredData).additional_information_2 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_155, [
                              _createElementVNode("div", _hoisted_156, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  name: "additional_information_2",
                                  class: _normalizeClass(['form-control', ngKeyAdditionalInformation2.value || _unref(v$).additional_information_2.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_unref(v$).additional_information_2.$model) = $event)),
                                  onChange: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation2) && _unref(checkNGAdditionalInformation2)(...args))),
                                  placeholder: _unref(placeholderDefault),
                                  rows: "5"
                                }, null, 42, _hoisted_157), [
                                  [
                                    _vModelText,
                                    _unref(v$).additional_information_2.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeyAdditionalInformation2.value && !_unref(v$).additional_information_2.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_158, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_2_question,
                                  params: [1, 600],
                                  validator: _unref(v$).additional_information_2.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.additional_information_3 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_159, [
                            _createElementVNode("div", _hoisted_160, [
                              _createElementVNode("div", _hoisted_161, [
                                _createElementVNode("label", null, _toDisplayString(_unref(title_data)?.additional_information_3_question), 1),
                                (_unref(communityRequiredData).additional_information_3 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_163, [
                              _createElementVNode("div", _hoisted_164, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  name: "additional_information_3",
                                  class: _normalizeClass(['form-control', ngKeyAdditionalInformation3.value || _unref(v$).additional_information_3.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_unref(v$).additional_information_3.$model) = $event)),
                                  onChange: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation3) && _unref(checkNGAdditionalInformation3)(...args))),
                                  placeholder: _unref(placeholderDefault),
                                  rows: "5"
                                }, null, 42, _hoisted_165), [
                                  [
                                    _vModelText,
                                    _unref(v$).additional_information_3.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeyAdditionalInformation3.value && !_unref(v$).additional_information_3.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_166, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_3_question,
                                  params: [1, 600],
                                  validator: _unref(v$).additional_information_3.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.additional_information_4 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                            _createElementVNode("div", _hoisted_168, [
                              _createElementVNode("div", _hoisted_169, [
                                _createElementVNode("label", null, _toDisplayString(_unref(title_data)?.additional_information_4_question), 1),
                                (_unref(communityRequiredData).additional_information_4 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_171, [
                              _createElementVNode("div", _hoisted_172, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  name: "additional_information_4",
                                  class: _normalizeClass(['form-control', ngKeyAdditionalInformation4.value || _unref(v$).additional_information_4.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(v$).additional_information_4.$model) = $event)),
                                  onChange: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation4) && _unref(checkNGAdditionalInformation4)(...args))),
                                  placeholder: _unref(placeholderDefault),
                                  rows: "5"
                                }, null, 42, _hoisted_173), [
                                  [
                                    _vModelText,
                                    _unref(v$).additional_information_4.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeyAdditionalInformation4.value && !_unref(v$).additional_information_4.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_174, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_4_question,
                                  params: [1, 600],
                                  validator: _unref(v$).additional_information_4.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(communityRequiredData)?.additional_information_5 !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_175, [
                            _createElementVNode("div", _hoisted_176, [
                              _createElementVNode("div", _hoisted_177, [
                                _createElementVNode("label", null, _toDisplayString(_unref(title_data)?.additional_information_5_question), 1),
                                (_unref(communityRequiredData).additional_information_5 === 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_178, [
                                      _createVNode(Status)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("div", _hoisted_180, [
                                _withDirectives(_createElementVNode("textarea", {
                                  type: "text",
                                  name: "additional_information_5",
                                  class: _normalizeClass(['form-control', ngKeyAdditionalInformation5.value || _unref(v$).additional_information_5.$error ? 'is-invalid' : '']),
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_unref(v$).additional_information_5.$model) = $event)),
                                  onChange: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_unref(checkNGAdditionalInformation5) && _unref(checkNGAdditionalInformation5)(...args))),
                                  placeholder: _unref(placeholderDefault),
                                  rows: "5"
                                }, null, 42, _hoisted_181), [
                                  [
                                    _vModelText,
                                    _unref(v$).additional_information_5.$model,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (ngKeyAdditionalInformation5.value && !_unref(v$).additional_information_5.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_182, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(InputErrorMessage, {
                                  title: _unref(communityRequiredData).additional_information_5_question,
                                  params: [1, 600],
                                  validator: _unref(v$).additional_information_5.$errors[0]?.$validator
                                }, null, 8, ["title", "validator"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("h3", _hoisted_183, _toDisplayString(_unref(translate)('OE30corporationHistoryNotes')), 1),
                _createElementVNode("div", _hoisted_184, [
                  _hoisted_185,
                  _createElementVNode("div", _hoisted_186, [
                    _withDirectives(_createElementVNode("textarea", {
                      type: "text",
                      name: "information",
                      class: _normalizeClass(['form-control', ngKeyCorporationHistoryNote.value || _unref(v$).corporation_edit_history_notes.$error ? 'is-invalid' : '']),
                      "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_unref(v$).corporation_edit_history_notes.$model) = $event)),
                      onChange: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_unref(checkNGCorporationHistoryNote) && _unref(checkNGCorporationHistoryNote)(...args))),
                      rows: "5"
                    }, null, 34), [
                      [
                        _vModelText,
                        _unref(v$).corporation_edit_history_notes.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    (ngKeyCorporationHistoryNote.value && !_unref(v$).corporation_edit_history_notes.$error)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                      : _createCommentVNode("", true),
                    _createVNode(InputErrorMessage, {
                      title: _unref(translate)('OE30corporationHistoryNotes'),
                      validator: _unref(v$).corporation_edit_history_notes.$errors[0]?.$validator,
                      params: [300]
                    }, null, 8, ["title", "validator"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_188, [
            _createVNode(Button, {
              title: _unref(translate)('cancel'),
              type: 'secondary',
              onClick: onCloseModal,
              className: 'fw-bold'
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('titleButtonConfirm'),
              type: 'secondary',
              className: 'fw-bold',
              loading: loadingButton.value,
              onClick: onSubmit
            }, null, 8, ["title", "loading"])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: false })
  ], 64))
}
}

})